import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/defaultHooks';
import { getTheme } from '../../selectors/selectors';
import { Container, Row, Col } from 'react-bootstrap';
import image from './signIn-preview.svg';
import ImagePreview from '../../UIComponents/ImagePreview';
import Logo from '../../UIComponents/Logo';
import Button from '../../UIComponents/Button';
import { useRestorePasswordMutation } from '../../features/user/user.service';
import { Link, useParams } from 'react-router-dom';
import { isFetchBaseQueryError } from '../../utils/helpers';
import routes from '../../routes';
import { ToastContainer } from 'react-toastify';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const ForgotPasswordPage = () => {
  const theme = useAppSelector(getTheme);
  const params = useParams();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [successAnswer, setSuccessAnswer] = useState<boolean>(false);

  const [error, setError] = useState('');
  const [restorePassword] = useRestorePasswordMutation();
  useDocumentTitle('Password Recovery');
  const restorePasswordHandler = async () => {
    const { email, code } = params;
    try {
      setDisabled(true);
      const response = await restorePassword({
        email: email as string,
        code: code as string,
      }).unwrap();
      if (response.success) {
        setSuccessAnswer(true);
      }
    } catch (error) {
      if (isFetchBaseQueryError(error)) {
        if (error.status === 400) {
          setError('Email has already been sent to you. Check your email or try again later');
        }
        if (error.status === 404) {
          setError('User not found. Please contact administrator');
        }
        if (error.status === 412) {
          setError('Password cannot be changed. Please contact administrator');
        }
      }
    } finally {
      setDisabled(false);
    }
  };
  return (
    <Container className={`${theme}-root-container`} fluid>
      <Row className="align-items-center justify-content-around h-100">
        <Col
          xs={4}
          md={4}
          lg={4}
          className={`${theme}-secondary-container d-flex flex-column align-items-center justify-content-center h-100 gap-5`}
        >
          <Logo />
          {error && <p className="text-center">{error}</p>}
          {!successAnswer ? (
            <div className="d-flex flex-column w-50 text-center gap-5">
              <span>
                To generate a new password and receive it by email, click the Reset Password button
              </span>
              <Button
                theme={theme}
                text="Reset Password"
                clickHandler={restorePasswordHandler}
                disabled={disabled}
              />
            </div>
          ) : (
            <>
              <span>New password will be sent to your email.</span>
              <span>
                <Link to={routes.pages.signIn()}>Return to login page</Link>
              </span>
            </>
          )}
        </Col>
        <Col xs={8} md={8} lg={8} className="d-flex align-items-center justify-content-center">
          <ImagePreview url={image} />
        </Col>
      </Row>
      <ToastContainer autoClose={5000} theme={theme} />
    </Container>
  );
};

export default ForgotPasswordPage;
